import React, { useState } from 'react';
import { CheckCircle, AlertCircle, XCircle, Loader } from 'lucide-react';
import { Button } from '../ui/button';
import { Separator } from '../ui/separator';

import ActionConfirmationDialog from './ActionConfirmationDialog'; // Adjust the import path as necessary

const ActionButtons = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [actionType, setActionType] = useState('');
  const [comments, setComments] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const handleActionClick = action => {
    setActionType(action);
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
    setComments('');
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      // Dummy API call - replace with actual API endpoint
      const accessToken = localStorage.getItem('access_token');
      const refreshToken = localStorage.getItem('refresh_token');

      await new Promise(resolve => setTimeout(resolve, 1500)); // Simulated delay

      const response = await fetch('https://your-api-endpoint/action', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Access-Token': accessToken,
          'X-Refresh-Token': refreshToken
        },
        body: JSON.stringify({
          action: actionType,
          comments: comments,
          timestamp: new Date().toISOString()
        })
      });
      if (!response.ok) {
        throw new Error('API call failed');
      }
      setSnackbarMessage(
        `Successfully ${actionType === 'Referral' ? 'Referred' : actionType + 'd'
        }`
      );
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      handleClose();
    } catch (error) {
      setSnackbarMessage('Could not complete action, try again later');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      handleClose();
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
      setDialogOpen(false);
    }
  };

  return (
    <>
      {isLoading && (
        <div className='fixed top-0 left-0 w-screen h-screen bg-black/40 z-[9999] flex items-center justify-center'>
          <Loader className='animate-spin text-orange-600' size={60} />
        </div>
      )}

      <div className='flex justify-end space-x-2'>
        <div className='inline-flex rounded-md shadow-md'>
          <Button
            size='sm'
            variant='outline'
            className='rounded-l-md rounded-r-none'
          // onClick={() => handleActionClick('Approve')}
          >
            <CheckCircle className='h-3.5 w-3.5 mr-1' />
            Approve
          </Button>
          <Button
            size='sm'
            variant='outline'
            className='rounded-none border-l-0 border-r-0'
          // onClick={() => handleActionClick('Referral')}
          >
            <AlertCircle className='h-3.5 w-3.5 mr-1' />
            Referral
          </Button>
          <Button
            size='sm'
            variant='outline'
            className='rounded-r-md rounded-l-none'
          //` onClick={() => handleActionClick('Decline')}
          >
            <XCircle className='h-3.5 w-3.5 mr-1' />
            Decline
          </Button>
        </div>
        <Separator orientation='vertical' className='h-8 mx-2' />
        <Button
          size='sm'
          className='bg-[#FF5533] hover:bg-[#E04A2F] text-white disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none'
        >
          Submit
        </Button>
      </div>

      <ActionConfirmationDialog
        dialogOpen={dialogOpen}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
        actionType={actionType}
        comments={comments}
        setComments={setComments}
      ></ActionConfirmationDialog>

      {snackbarOpen && (
        <div
          className={`fixed top-4 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded shadow-lg flex items-center space-x-2 ${snackbarSeverity === 'success'
              ? 'bg-green-100 text-green-700'
              : 'bg-red-100 text-red-700'
            }`}
        >
          {snackbarSeverity === 'success' ? (
            <CheckCircle className='h-5 w-5' />
          ) : (
            <XCircle className='h-5 w-5' />
          )}
          <span>{snackbarMessage}</span>
          <button
            className='ml-2 text-gray-500 hover:text-gray-700'
            onClick={() => setSnackbarOpen(false)}
          >
            <XCircle className='h-4 w-4' />
          </button>
        </div>
      )}
    </>
  );
};

export default ActionButtons;
